// Welche Teile des Vuex-Stands im localStorage überleben.
//
// Früher wurde der komplette Stand gespeichert, samt Schießbuch, Mitglieder-
// und Waffenlisten. Safari (vor allem auf dem iPhone) erlaubt nur rund 5 MB;
// war das voll, brach jede Store-Änderung mit „QuotaExceededError“ ab und die
// Ansicht blieb auf altem Stand stehen. Gespeichert wird deshalb nur noch, was
// einen Neustart überstehen muss: Anmeldung, Menüs und ein paar Einstellungen.
// Alle Listen lädt die App beim Start bzw. beim Öffnen der Ansicht neu.

export const PERSIST_PATHS = [
  'UserAuth.status',
  'UserAuth.token',
  'UserAuth.user',
  'UserAuth.defClub',
  'UserAuth.usermenu',
  'ClubAuth.status',
  'ClubAuth.Clubtoken',
  'ClubAuth.club',
  'ClubAuth.clubmenu',
  'ClubAuth.club_qrcode',
  'GeneralApp.NavigationDrawer',
  'GeneralApp.Show_Navigation',
  'UserApp.PoolFilters',
  'ClubApp.WeaponPoolShowOnlyActive',
];

function pick(source, paths) {
  const result = {};
  paths.forEach(path => {
    const keys = path.split('.');
    let value = source;
    for (const key of keys) {
      if (value === null || typeof value !== 'object' || !(key in value)) return;
      value = value[key];
    }
    let target = result;
    keys.slice(0, -1).forEach(key => {
      target = target[key] = target[key] || {};
    });
    target[keys[keys.length - 1]] = value;
  });
  return result;
}

// Ersatz für das setState von vuex-persistedstate: Ein voller Speicher darf
// die App nicht abbrechen lassen, dann wird eben nicht gespeichert.
export function safeSetState(key, state, storage) {
  try {
    storage.setItem(key, JSON.stringify(state));
  } catch (error) {
    // Speicher voll oder gesperrt
  }
}

// Einmalig beim Start: einen alten, kompletten Stand auf die gespeicherten
// Pfade eindampfen. Das gibt auf betroffenen Geräten den Speicher wieder frei.
export function shrinkStoredState(storage, key) {
  try {
    const raw = storage.getItem(key);
    if (!raw) return;
    const reduced = JSON.stringify(pick(JSON.parse(raw), PERSIST_PATHS));
    if (reduced.length < raw.length) {
      storage.removeItem(key);
      storage.setItem(key, reduced);
    }
  } catch (error) {
    try {
      storage.removeItem(key);
    } catch (ignored) {
      // localStorage nicht verfügbar
    }
  }
}
